import React, { useEffect, useState } from 'react';
import styles from './Factory.module.scss';
import Text from '../../../../atoms/text/Text';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { closeAllModals } from '../../../../../app/globals/slice/sideModalSlice/SideModalSlice';
import useIsRtl from '../../../../../app/helpers/isRtl';
const arrowRight = '/assets/svg/arrow_rightGrey.svg';

const navigateTo = (item, navigate, dispatch) => {
  if (!item?.route) return;
  dispatch(closeAllModals());
  setTimeout(() => {
    navigate(item.route, {
      state: item.routeState,
      replace: item.shouldReplace,
    });
  }, 500);
};

const MobileMenu = ({ data, className = '', isRtl, textClassName = '' }) => {
  const [activeLink, setActiveLink] = useState(null);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = (index, item) => {
    if (!item?.children && item.route) {
      navigateTo(item, navigate, dispatch);
    } else {
      setActiveLink(activeLink === index ? null : index);
    }
  };

  return (
    <div
      className={`${styles.menu} ${className ?? ''} ${
        isRtl ? styles['rtl-menu'] : ''
      }`}
    >
      <Link
        to="/"
        replace
        style={{ textDecoration: 'none', cursor: 'pointer' }}
        className={styles['nav-link']}
        onClick={() => {
          dispatch(closeAllModals());
          setActiveLink(null);
        }}
      >
        <Text
          variant="text-regular-18"
          title="home.home_page"
          color="black"
          className={textClassName}
          style={{ cursor: 'pointer' }}
        />
      </Link>
      {data?.map((item, index) => {
        if (item.hidden) return null;

        const textClass = `${styles.link} ${
          activeLink === index ? styles['active-link'] : ''
        } ${textClassName}`;
        const isActive = activeLink === index;

        return (
          <>
            <Link
              to={item.route || '#'}
              state={item.routeState}
              replace={item.shouldReplace}
              onClick={(e) => {
                e.preventDefault();
                handleClick(index, item);
              }}
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              className={`${styles['nav-link']} ${isActive ? styles['nav-link-active'] : ''}`}
            >
              <Text
                variant="text-regular-18"
                title={item.title}
                className={textClass}
                onClick={() => handleClick(index, item)}
              />
              {item?.children ? (
                <img
                  src={arrowRight}
                  alt=""
                  className={`${styles.arrow} ${isActive ? styles['arrow-active'] : ''} ${isRtl && !isActive ? styles['rtl-image'] : styles['rtl-image-active']}`}
                />
              ) : null}
            </Link>
            {activeLink === index && (
              <Navigation
                data={item?.children}
                item={item}
                textClass={styles['child-nav']}
              />
            )}
          </>
        );
      })}
    </div>
  );
};

const Navigation = ({ data, textClass }) => {
  const isRtl = useIsRtl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const gridClass =
    data && data[2]?.children
      ? `${styles['sub-menu']} ${styles['flexed-row']} ${isRtl ? styles['sub-menu-rtl'] : ''}`
      : `${styles['sub-menu']} ${isRtl ? styles['sub-menu-rtl'] : ''}`;

  useEffect(() => {
    const lang = localStorage.getItem('language');
    if (lang === 'ar') {
      setLoading(false);
    } else {
      const timeout = setTimeout(() => setLoading(false), 150);
      return () => clearTimeout(timeout);
    }
  }, []);
  const blurryClass = styles.blurry;
  return (
    <div className={styles.navigation}>
      <div className={gridClass}>
        {data?.map((child, index) => {
          if (child?.hidden) return null;

          if (child?.children) {
            return (
              <div
                key={child.id || `child-${index}`}
                className={styles['inner-child-container']}
              >
                <Text
                  variant="text-regular-16"
                  title={child.title}
                  className={`${styles['child-link']} ${loading ? blurryClass : ''} ${loading ? 'blurry' : ''} ${textClass}`}
                  onClick={() => navigateTo(child, navigate, dispatch)}
                />
                {child.children?.map((sub, subIndex) => (
                  <Link
                    to={sub.route || '#'}
                    state={sub.routeState}
                    replace={sub.shouldReplace}
                    onClick={(e) => {
                      e.preventDefault();
                      navigateTo(sub, navigate, dispatch);
                    }}
                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                    className={styles['inner-child-link']}
                  >
                    <Text
                      variant="text-regular-14"
                      title={sub.title}
                      className={`${styles['child-link']} ${loading ? blurryClass : ''} ${loading ? 'blurry' : ''}`}
                      onClick={() => navigateTo(sub, navigate, dispatch)}
                    />
                  </Link>
                ))}
              </div>
            );
          } else {
            return (
              <Link
                key={child.id || `main-${index}`}
                to={child.route || '#'}
                state={child.routeState}
                replace={child.shouldReplace}
                onClick={(e) => {
                  e.preventDefault();
                  navigateTo(child, navigate, dispatch);
                }}
                style={{ textDecoration: 'none', cursor: 'pointer' }}
                className={`${styles['main-child-link']} ${loading ? blurryClass : ''}`}
              >
                <Text
                  variant="text-regular-16"
                  title={child.title}
                  className={`${styles['main-child-link']} ${loading ? blurryClass : ''} ${textClass}`}
                />
              </Link>
            );
          }
        })}
      </div>
    </div>
  );
};

export { MobileMenu, Navigation };
